"use client";

import { useEffect, useState } from "react";
import { HomePage } from "../sections/HomePage";
import { captureInviteCode } from "../lib/invite";
import { Shell } from "./Shell";
import type { SiteData } from "../site-data";

/**
 * The homepage, and the one piece of state the shell used to hold (`WEB-044`).
 *
 * `WEB-024`: the masthead's Honorable Mentions link is decided from the board, and the board
 * lives here. It starts `false` so a board with no mentions never shows the link and then
 * removes it — cold start is the common case, not the exception.
 *
 * The board itself arrives as a prop from the server component above (`D-015`'s build-time
 * reads), so nothing on this page fetches it and nothing about `D-015` changed except which
 * build system performs the read.
 */
export function HomeView({ data }: { data: SiteData }) {
  const [mentionsOnBoard, setMentionsOnBoard] = useState(false);

  /*
   * Lifts a founder invite code out of the address bar so it does not travel on into a
   * `Referer` header or a shared link (`src/lib/invite.ts`).
   *
   * In an effect rather than at module scope since `D-020`. `main.tsx` called it before
   * `createRoot`, which was safe when the only environment was a browser; the same call at
   * module scope now would run during the build, where there is no address bar, and reach
   * for `window` while prerendering. An effect runs in the browser and only in the browser,
   * which is the condition this always actually wanted.
   */
  useEffect(() => {
    captureInviteCode();
  }, []);

  return (
    <Shell honorableMentions={mentionsOnBoard}>
      <HomePage onHonorableMentions={setMentionsOnBoard} data={data} />
    </Shell>
  );
}
